// src/api/vendor-balance/vendorBalanceApi.js
import axiosClient from '../axiosClient';

export const vendorBalanceApi = {

  getVendorBalances: async (page = 0, size = 20, search = '') => {
    try {
      const params = new URLSearchParams({ page: page.toString(), size: size.toString() });
      if (search && search.trim() !== '') params.append('search', search.trim());
      const data = await axiosClient.get(`/vendor-balance?${params.toString()}`);
      return data;
    } catch (error) {
      console.error('Error fetching vendor balances:', error);
      throw error;
    }
  },

  exportVendorBalances: async (search = '') => {
    try {
      const params = new URLSearchParams();
      if (search && search.trim() !== '') params.append('search', search.trim());
      const data = await axiosClient.get(`/vendor-balance/export?${params.toString()}`);
      return data;
    } catch (error) {
      console.error('Error exporting vendor balances:', error);
      throw error;
    }
  },

  getVendorBalanceStats: async () => {
    try {
      const data = await axiosClient.get('/vendor-balance/stats');
      return data;
    } catch (error) {
      console.error('Error fetching vendor balance stats:', error);
      throw error;
    }
  },

  getTopOutstanding: async (search = '') => {
    try {
      const params = new URLSearchParams();
      if (search && search.trim() !== '') params.append('search', search.trim());
      const data = await axiosClient.get(`/vendor-balance/top-outstanding?${params.toString()}`);
      return data;
    } catch (error) {
      console.error('Error fetching top outstanding:', error);
      throw error;
    }
  },
};